// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.refundRequestContainer {
  padding: 20px;
  max-width: 800px;
  height: 100%;
  overflow-y: auto; /* 스크롤 추가 */
}

.pageTitle {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 6px;
}

.pageDescription {
  color: #666;
  margin-bottom: 18px;
}

.refundSection {
  margin-bottom: 0px;
  margin-top: -100px !important;
}

.sectionTitle {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px !important;
}

.infoBox {
  background-color: #FFF5E9;
  border-radius: 8px;
  padding: 16px;
}

.infoBox p {
  margin: 3px 0;
  font-size: 16px;
}

/* 커스텀 드롭다운 스타일 */
.customDropdownContainer {
  position: relative;
  width: 100%;
  max-width: 500px;
  margin-bottom: 16px;
  z-index: 10;
}

.customDropdownHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background-color: #FFF5E9;
  border: 1px solid #EEE4D5;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
}

.dropdownArrow {
  font-size: 12px;
  transition: transform 0.3s;
}

.dropdownArrow.open {
  transform: rotate(180deg);
}

.customDropdownOptions {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background-color: #FFF5E9;
  border: 1px solid #EEE4D5;
  border-top: none;
  border-radius: 0 0 8px 8px;
  z-index: 10;
  max-height: 200px;
  overflow-y: auto;
}

.customDropdownOption {
  padding: 10px 16px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.customDropdownOption:hover {
  background-color: #F0E5D5;
}

/* 직접 입력 텍스트 영역 스타일 */
.customReasonContainer {
  margin-top: 12px;
  width: 100%;
  max-width: 500px;
}

.customReasonTextarea {
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 16px;
  resize: vertical;
  min-height: 120px;
  background-color: #fff;
}

.customReasonTextarea::placeholder {
  color: #aaa;
}

.refundPolicyContainer {
  margin-bottom: 24px;
}

.refundPolicyButton {
  background-color: #f2f2ff;
  border: none;
  border-radius: 8px;
  padding: 12px 16px;
  color: #333;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 400px;
  text-align: left;
  position: relative;
}

.arrowIcon {
  position: absolute;
  right: 20px;
  font-size: 25px !important;
}

.submitContainer {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  margin-bottom: 20px;
}

.submitButton {
  background-color: #FF6B00;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.2s;
}

.submitButton:hover {
  background-color: #E55F00;
}

/* 모바일 대응 */
@media (max-width: 768px) {
  .refundRequestContainer {
    padding: 12px;
  }
  
  .submitButtonContainer {
    padding: 12px;
  }
  
  .submitButton {
    width: 100%;
    max-width: none;
  }
  
  .infoBox {
    padding: 12px;
  }
  
  .customDropdownContainer,
  .customReasonContainer {
    max-width: 100%;
  }
}

.leftAligned {
  text-align: left !important;
  margin-left: 0 !important;
  padding-left: 0 !important;
  justify-content: flex-start !important;
}

/* 로딩, 에러 메시지 스타일 */
.loadingMessage,
.errorMessage,
.emptyMessage {
  text-align: center;
  padding: 16px;
  font-size: 16px;
  color: #666;
  background-color: #f5f5f5;
  border-radius: 8px;
  margin-top: 16px;
}

.errorMessage {
  color: #e53935;
  background-color: #ffebee;
}

.emptyMessage {
  color: #0d47a1;
  background-color: #e3f2fd;
} `, "",{"version":3,"sources":["webpack://./src/styles/RefundRequest.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,gBAAgB,EAAE,WAAW;AAC/B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,0BAA0B;EAC1B,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,WAAW;AACX;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA,mBAAmB;AACnB;;;EAGE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B","sourcesContent":[".refundRequestContainer {\n  padding: 20px;\n  max-width: 800px;\n  height: 100%;\n  overflow-y: auto; /* 스크롤 추가 */\n}\n\n.pageTitle {\n  font-size: 24px;\n  font-weight: bold;\n  margin-bottom: 6px;\n}\n\n.pageDescription {\n  color: #666;\n  margin-bottom: 18px;\n}\n\n.refundSection {\n  margin-bottom: 0px;\n  margin-top: -100px !important;\n}\n\n.sectionTitle {\n  font-size: 18px;\n  font-weight: bold;\n  margin-bottom: 10px !important;\n}\n\n.infoBox {\n  background-color: #FFF5E9;\n  border-radius: 8px;\n  padding: 16px;\n}\n\n.infoBox p {\n  margin: 3px 0;\n  font-size: 16px;\n}\n\n/* 커스텀 드롭다운 스타일 */\n.customDropdownContainer {\n  position: relative;\n  width: 100%;\n  max-width: 500px;\n  margin-bottom: 16px;\n  z-index: 10;\n}\n\n.customDropdownHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 16px;\n  background-color: #FFF5E9;\n  border: 1px solid #EEE4D5;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 16px;\n}\n\n.dropdownArrow {\n  font-size: 12px;\n  transition: transform 0.3s;\n}\n\n.dropdownArrow.open {\n  transform: rotate(180deg);\n}\n\n.customDropdownOptions {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  background-color: #FFF5E9;\n  border: 1px solid #EEE4D5;\n  border-top: none;\n  border-radius: 0 0 8px 8px;\n  z-index: 10;\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.customDropdownOption {\n  padding: 10px 16px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.customDropdownOption:hover {\n  background-color: #F0E5D5;\n}\n\n/* 직접 입력 텍스트 영역 스타일 */\n.customReasonContainer {\n  margin-top: 12px;\n  width: 100%;\n  max-width: 500px;\n}\n\n.customReasonTextarea {\n  width: 100%;\n  padding: 12px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  font-size: 16px;\n  resize: vertical;\n  min-height: 120px;\n  background-color: #fff;\n}\n\n.customReasonTextarea::placeholder {\n  color: #aaa;\n}\n\n.refundPolicyContainer {\n  margin-bottom: 24px;\n}\n\n.refundPolicyButton {\n  background-color: #f2f2ff;\n  border: none;\n  border-radius: 8px;\n  padding: 12px 16px;\n  color: #333;\n  font-size: 16px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  max-width: 400px;\n  text-align: left;\n  position: relative;\n}\n\n.arrowIcon {\n  position: absolute;\n  right: 20px;\n  font-size: 25px !important;\n}\n\n.submitContainer {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n\n.submitButton {\n  background-color: #FF6B00;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  padding: 12px 24px;\n  font-size: 16px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.submitButton:hover {\n  background-color: #E55F00;\n}\n\n/* 모바일 대응 */\n@media (max-width: 768px) {\n  .refundRequestContainer {\n    padding: 12px;\n  }\n  \n  .submitButtonContainer {\n    padding: 12px;\n  }\n  \n  .submitButton {\n    width: 100%;\n    max-width: none;\n  }\n  \n  .infoBox {\n    padding: 12px;\n  }\n  \n  .customDropdownContainer,\n  .customReasonContainer {\n    max-width: 100%;\n  }\n}\n\n.leftAligned {\n  text-align: left !important;\n  margin-left: 0 !important;\n  padding-left: 0 !important;\n  justify-content: flex-start !important;\n}\n\n/* 로딩, 에러 메시지 스타일 */\n.loadingMessage,\n.errorMessage,\n.emptyMessage {\n  text-align: center;\n  padding: 16px;\n  font-size: 16px;\n  color: #666;\n  background-color: #f5f5f5;\n  border-radius: 8px;\n  margin-top: 16px;\n}\n\n.errorMessage {\n  color: #e53935;\n  background-color: #ffebee;\n}\n\n.emptyMessage {\n  color: #0d47a1;\n  background-color: #e3f2fd;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
